module.exports = __webpack_public_path__ + "media/images/icons/production-022ca1f6aa9996e7f02ef6ff46099029.svg";